import logger from '@logger'

// 164 = size of the header + spacings
const HEADER_HEIGHT = 164

export const scrollToElement = (offset) => {
  return window.scrollTo({
    behavior: 'smooth',
    top: offset - HEADER_HEIGHT,
  })
}

/**
 * Formats logger error used for reviews endpoints
 * @param tags A list of strings to append to the log message
 * @param err The error object to add to the log
 *
 * @example logReviewsError({ tags: ['product'], err: { message: 'not found'}})
 * > [COMMUNITY][product] not found
 * > Attributes: { err: { message: 'not found' }}
 *
 * @example logReviewsError({ tags: ['product', 'filter']})
 * > [COMMUNITY][product][filter]
 */
export const logReviewsError = ({ tags = [], err = {} } = {}) => {
  const formattedTags = tags.map((tag) => `[${tag}]`).join('')
  const error = err?.message || ''

  const message = `[COMMUNITY]${formattedTags} ${error}`.trim()
  if (err?.status_code > 499) logger.error(message, err)
  else logger.info(message, err)
}
